import { createSelector } from "reselect";

import slice from "./slice";

export const selectDeployments = createSelector(slice.selector, (state) =>
  Object.values(state.entities),
);
